angular.module('eStories.browse', [
    'eStories.catalog.model',
    'eStories.compnt.grid',
    'eStories.paging.model',
    'eStories.sortFilter'
])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.browse', {
                url: 'browse?pageNumber&genreId&&subGenreId&sortField&languageId&duration&abridged&onlyForCredit&onlyForFree&onlyOnSale',
                views: {
                    'mainView@': {
                        controller: 'BrowseCtrl as browseCtrl',
                        templateUrl: 'store/browse/browse.tmpl.html'
                    }
                }
            });
    }])

    .controller('BrowseCtrl', [
        'CatalogModel',
        'PagingModel',
        'SortFilterFactory',
        '$rootScope',
        '$stateParams',
        '$location',
        '$scope',
        '$state',
        '$window',
        '$timeout',
        'LL',
        'SeoModel',
        'GA',
        function (CatalogModel,
                  PagingModel,
                  SortFilterFactory,
                  $rootScope,
                  $stateParams,
                  $location,
                  $scope,
                  $state,
                  $window,
                  $timeout,
                  LL,
                  SeoModel,
                  GA) {

            const browseCtrl = this;

            browseCtrl.currentState = $state.current.name;
            browseCtrl.bioCharacterLimit = 730;

            GA.trackPageView($location.url());

            $rootScope.$on("windowResized", function (event) {
                if ($window.innerWidth < 650) {
                    browseCtrl.listView = false
                } else {
                    browseCtrl.listView = SortFilterFactory.listViewMode[browseCtrl.currentState].mode;
                }
            });

            browseCtrl.initPublisher = async () => {
                const response = await CatalogModel.getPublisher(parseInt($stateParams.publisherId));
                if (response.responseStatus !== 'SUCCESS') {
                    return;
                }
                LL.tagEvent('Browsed Publisher', {'Publisher Name': response.publisher.name});
                browseCtrl.entityBio = response.publisher.bio;
                SeoModel.applyPublisherMetaTags(response.publisher.name);
                if (browseCtrl.entityBio) {
                    browseCtrl.cropBio = browseCtrl.entityBio.length > browseCtrl.bioCharacterLimit;
                }
                $timeout(function () {
                    $rootScope.$broadcast('setName', response.publisher.name);
                }, 0)
            };

            browseCtrl.initAuthor = async () => {
                const response = await CatalogModel.getAuthor(parseInt($stateParams.authorId));
                if (response.responseStatus !== 'SUCCESS') {
                    return;
                }

                LL.tagEvent('Browsed Author', {'Author Name': response.author.name});
                browseCtrl.entityBio = response.author.bio;
                browseCtrl.author = response.author;

                SeoModel.applyAuthorMetaTags(browseCtrl.author.name);
                if (browseCtrl.entityBio) {
                    browseCtrl.cropBio = browseCtrl.entityBio.length > browseCtrl.bioCharacterLimit;
                }
                $timeout(function () {
                    $rootScope.$broadcast('setName', response.author.name);
                }, 0)
            };

            browseCtrl.initNarrator = async () => {
                const response = await CatalogModel.getNarrator(parseInt($stateParams.narratorId));
                if (response.responseStatus !== 'SUCCESS') {
                    return;
                }

                LL.tagEvent('Browsed Narrator', {'Narrator Name': response.narrator.name});
                SeoModel.applyNarratorMetaTags(response.narrator.name);
                browseCtrl.entityBio = response.narrator.bio;
                if (browseCtrl.entityBio) {
                    browseCtrl.cropBio = browseCtrl.entityBio.length > browseCtrl.bioCharacterLimit;
                }
                $timeout(function () {
                    $rootScope.$broadcast('setName', response.narrator.name);
                }, 0)
            };

            if (browseCtrl.currentState === 'eStories.navbars.publisher' ||
                browseCtrl.currentState === 'eStories.navbars.publisherFull') {
                browseCtrl.initPublisher().then();
            } else if (browseCtrl.currentState === 'eStories.navbars.author' ||
                browseCtrl.currentState === 'eStories.navbars.authorFull') {
                browseCtrl.initAuthor().then();
            } else if (browseCtrl.currentState === 'eStories.navbars.narrator' ||
                browseCtrl.currentState === 'eStories.navbars.narratorFull') {
                browseCtrl.initNarrator().then();
            } else {
                SeoModel.applyMetaTags($state.current.name);
            }

            PagingModel.updatePageNumber(browseCtrl.currentState, parseInt($stateParams.pageNumber) || 1);

            if (PagingModel.pagingData[browseCtrl.currentState].totalCount == null) {
                SortFilterFactory.resetFilterObj();
            }

            //Extracts all the get Params , uses the previous saved Params and updates them
            var globalFilterObj = SortFilterFactory.filterObj;
            globalFilterObj.languageId = $stateParams.languageId != null ? $stateParams.languageId : globalFilterObj.languageId;


            globalFilterObj.onlyForCredit = $stateParams.onlyForCredit || globalFilterObj.onlyForCredit;
            globalFilterObj.onlyForFree = $stateParams.onlyForFree || globalFilterObj.onlyForFree;
            globalFilterObj.onlyOnSale = $stateParams.onlyOnSale || globalFilterObj.onlyOnSale;


            globalFilterObj.genreId = $stateParams.genreId != null ? parseInt($stateParams.genreId) : globalFilterObj.genreId;
            globalFilterObj.subGenreId = $stateParams.subGenreId != null ? parseInt($stateParams.subGenreId) : globalFilterObj.subGenreId;
            globalFilterObj.sortField = $stateParams.sortField || 'most_popular';
            globalFilterObj.duration = $stateParams.duration || globalFilterObj.duration;
            globalFilterObj.abridged = $stateParams.abridged || globalFilterObj.abridged;
            browseCtrl.descendingOrder = true;

            $rootScope.$on('changeGridView', function (event, toggle) {
                browseCtrl.listView = toggle;
                SortFilterFactory.listViewMode[browseCtrl.currentState].mode = toggle;
                safeApply($scope);
            });

            /*Request Obj*/
            browseCtrl.sortField = globalFilterObj.sortField != null ? globalFilterObj.sortField.toUpperCase() : null;

            browseCtrl.browseFilter = {
                abridged: globalFilterObj.abridged != null ? JSON.parse(globalFilterObj.abridged) : null,


                onlyForFree: globalFilterObj.onlyForFree != null ? JSON.parse(globalFilterObj.onlyForFree) : null,
                onlyForCredit: globalFilterObj.onlyForCredit != null ? JSON.parse(globalFilterObj.onlyForCredit) : null,
                onlyOnSale: globalFilterObj.onlyOnSale != null ? JSON.parse(globalFilterObj.onlyOnSale) : null


            };

            browseCtrl.browseFilter.genreIdList = globalFilterObj.genreId == null ? null : [globalFilterObj.genreId];
            if (globalFilterObj.subGenreId != null) {
                browseCtrl.browseFilter.genreIdList = [globalFilterObj.subGenreId];
            }

            if (globalFilterObj.languageId != null) {
                browseCtrl.browseFilter.languageIdList = [];
                var languageArray = globalFilterObj.languageId.split(',');
                for (var i = 0; i < languageArray.length; i++) {
                    browseCtrl.browseFilter.languageIdList.push(parseInt(languageArray[i]));
                }
            }

            if (globalFilterObj.duration != null) {
                browseCtrl.browseFilter.durationFilterList = [];
                var durationArray = globalFilterObj.duration.split(',');
                for (i = 0; i < durationArray.length; i++) {

                    var c = durationArray[i];
                    browseCtrl.browseFilter.durationFilterList.push({
                        minHours: c.match(/.+?(?=-)/) != null ? parseInt(c.match(/.+?(?=-)/)) : null,
                        maxHours: c.match(/[^-]+$/) != null ? parseInt(c.match(/[^-]+$/)) : null
                    });
                }
            }

            //Check sortField alphabetical descending status
            if (globalFilterObj.sortField !== null) {
                if (globalFilterObj.sortField === 'alphabetically') {
                    browseCtrl.descendingOrder = false;
                } else if (globalFilterObj.sortField === 'alphabetically_descending') {
                    browseCtrl.sortField = 'ALPHABETICALLY';
                }
            }

            //If in publisher page
            if ((browseCtrl.currentState === 'eStories.navbars.publisher' ||
                browseCtrl.currentState === 'eStories.navbars.publisherFull') && $stateParams.publisherId != null) {
                browseCtrl.browseFilter.publisherId = parseInt($stateParams.publisherId);
                //get PublisherName
            } else if ((browseCtrl.currentState === 'eStories.navbars.author' ||
                browseCtrl.currentState === 'eStories.navbars.authorFull') && $stateParams.authorId != null) {
                browseCtrl.browseFilter.authorId = parseInt($stateParams.authorId);
                //get AuthorName
            } else if ((browseCtrl.currentState === 'eStories.navbars.narrator' ||
                browseCtrl.currentState === 'eStories.navbars.narratorFull') && $stateParams.narratorId != null) {
                browseCtrl.browseFilter.narratorId = parseInt($stateParams.narratorId);
                //get NarratorName
            }

            // Grid View or List View when loading
            if (browseCtrl.currentState !== 'eStories.navbars.genre') {
                if (browseCtrl.currentState !== 'eStories.navbars.browse') {
                    browseCtrl.listView = $window.innerWidth < 650 ? false : SortFilterFactory.listViewMode[browseCtrl.currentState].mode;
                } else {
                    browseCtrl.listView = $window.innerWidth < 650 ? false : SortFilterFactory.listViewMode[browseCtrl.currentState].mode;
                    if (CatalogModel.cachedGenreCarouselSlides) {
                        browseCtrl.genreCarouselSlides = CatalogModel.cachedGenreCarouselSlides;
                    } else {
                        CatalogModel.getSectionList(['FEATURED_GENRES']).then(r => {
                            browseCtrl.genreCarouselSlides = r.sectionList;
                            CatalogModel.cachedGenreCarouselSlides = r.sectionList;
                        });
                    }
                }
            }

            /*End of request obj*/
            browseCtrl.getAuthorHeaderContent = function (data) {
                if (browseCtrl.currentState === 'eStories.navbars.author' ||
                    browseCtrl.currentState === 'eStories.navbars.authorFull') {
                    if (data) {
                        browseCtrl.authorHeaderCovers = data.slice(0, 5);
                        CatalogModel.authorHeaderCovers = browseCtrl.authorHeaderCovers;
                    } else {
                        browseCtrl.authorHeaderCovers = CatalogModel.authorHeaderCovers;
                    }
                    browseCtrl.fbq(browseCtrl.audiobookBrowseList);

                }
            };

            browseCtrl.getNarratorHeaderContent = function (data) {
                if (browseCtrl.currentState === 'eStories.navbars.narrator' ||
                    browseCtrl.currentState === 'eStories.navbars.narratorFull') {
                    if (data) {
                        browseCtrl.narratorHeaderCovers = data.slice(0, 5);
                        CatalogModel.narratorHeaderCovers = browseCtrl.narratorHeaderCovers;
                    } else {
                        browseCtrl.narratorHeaderCovers = CatalogModel.narratorHeaderCovers;

                    }
                    browseCtrl.fbq(browseCtrl.narratorHeaderCovers);
                }
            };

            browseCtrl.getPublisherHeaderContent = function (data) {
                if (browseCtrl.currentState === 'eStories.navbars.publisher' ||
                    browseCtrl.currentState === 'eStories.navbars.publisherFull') {
                    if (data) {
                        browseCtrl.publisherHeaderCovers = data.slice(0, 5);
                        CatalogModel.publisherHeaderCovers = browseCtrl.publisherHeaderCovers;
                    } else {
                        browseCtrl.publisherHeaderCovers = CatalogModel.publisherHeaderCovers;
                    }
                    browseCtrl.fbq(browseCtrl.publisherHeaderCovers);
                }
            };

            //Parent function
            browseCtrl.getPage = async function (pageNumber, callbackFunc, isMobile) {
                browseCtrl.callInProgress = true;
                browseCtrl.askForTotalCount = PagingModel.pagingData[browseCtrl.currentState].totalCount == null;

                var pagination = PagingModel.preparePagination(
                    pageNumber,
                    null,
                    browseCtrl.descendingOrder,
                    browseCtrl.askForTotalCount,
                    browseCtrl.sortField
                );

                const response = await CatalogModel.getAllAudiobooks(browseCtrl.browseFilter,
                    pagination, null);

                if (response.responseStatus !== 'SUCCESS') {
                    return;
                }

                if (isMobile && pageNumber > 1) {
                    browseCtrl.audiobookBrowseList = browseCtrl.audiobookBrowseList.concat(response.audiobookList)
                } else {
                    browseCtrl.audiobookBrowseList = response.audiobookList;
                    browseCtrl.getAuthorHeaderContent(response.audiobookList);
                    browseCtrl.getNarratorHeaderContent(response.audiobookList);
                    browseCtrl.getPublisherHeaderContent(response.audiobookList);
                }

                if (browseCtrl.askForTotalCount) {
                    PagingModel.updateResultsData(browseCtrl.currentState, response.totalCount);
                } else {
                    PagingModel.updateResultsData(browseCtrl.currentState, null);
                }

                browseCtrl.callInProgress = false;

                if (callbackFunc) {
                    callbackFunc(response);
                }
            };

            /*Initial Call*/


            browseCtrl.getPage(PagingModel.pagingData[browseCtrl.currentState].pageNumber, function (response) {
                if (browseCtrl.currentState === 'eStories.navbars.publisher' ||
                    browseCtrl.currentState === 'eStories.navbars.publisherFull') {
                    browseCtrl.headerAudiobookCoverArray = response.audiobookList.slice(0, 12);
                }
            });

            browseCtrl.fbq = function (content) {
                if (content.length > 1) {
                    var firstTenBooks = [];
                    for (var i = 0; (content.length > 10 ? i < 10 : i < content.length); i++) {
                        firstTenBooks.push(content[i].id)
                    }
                    fbq('track', 'ViewContent',
                        {
                            content_type: 'product',
                            content_ids: firstTenBooks
                        }
                    );
                } else {
                    fbq('track', 'ViewContent',
                        {
                            content_type: 'product',
                            content_ids: [content.id]
                        }
                    );
                }

            };

            //Runs genre filter
            browseCtrl.filterPageByGenre = async function () {
                const response = await CatalogModel.getAllAudiobooks(browseFilter, getDefaultPagination(null, ''), null);
                browseCtrl.audiobookBrowseList = response.audiobookList;
            };

            function constructGetParamsObj(pageNumber, filterObj) {
                //Save pagingData currentPage globally

                PagingModel.pagingData.currentPage = pageNumber;

                for (var param in globalFilterObj) {
                    if (globalFilterObj[param] == null) {
                        delete globalFilterObj[param];
                    }
                }
                globalFilterObj.pageNumber = pageNumber;
                if (filterObj && filterObj.obj != null) {
                    if (filterObj.filterType === 'genreId') {
                        delete globalFilterObj.subGenreId;
                    }
                    globalFilterObj[filterObj.filterType] = filterObj.obj;
                }
                return globalFilterObj
            }

            /*Listener to paging component*/
            $scope.$on('getPage', function (event, pageNumber) {
                if (browseCtrl.callInProgress) {
                    return;
                }
                var filterObj = constructGetParamsObj(pageNumber);
                $location.search(filterObj);
            });

            $scope.$on('loadMore', function (event, pageNumber) {
                PagingModel.pagingData[browseCtrl.currentState].pageNumber = pageNumber;
                browseCtrl.getPage(pageNumber, null, true);
            });

            //Listener to sortFilter Component
            $scope.$on('updateFilter', function (event, filterObj) {
                //Todo: Only reset counts when filtering , not sorting!!!!
                PagingModel.pagingData[browseCtrl.currentState].totalCount = null;
                PagingModel.pagingData[browseCtrl.currentState].totalPageCount = null;
                filterObj = constructGetParamsObj(null, filterObj);
                $location.search(filterObj);
            });
        }]);